import { rect, cRect } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

// Elongated figure, long torso and legs
export const body_tall: Hull = {
  id: 'body_tall',
  name: 'Tall',
  drawBody: (ctx, p) => {
    // Head
    rect(ctx, 27, 2, 10, 11, p.light);
    rect(ctx, 27, 2, 1, 11, p.shadow);
    rect(ctx, 36, 2, 1, 11, p.shadow);
    rect(ctx, 28, 2, 8, 1, p.shadow);
    rect(ctx, 28, 12, 8, 1, p.shadow);
    // Long neck
    rect(ctx, 30, 13, 4, 4, p.light);
    // Shoulders
    cRect(ctx, 17, 14, 2, p.light);
    // Arms
    rect(ctx, 23, 19, 4, 16, p.light);
    rect(ctx, 37, 19, 4, 16, p.light);
    // Torso (taller)
    rect(ctx, 26, 19, 12, 16, p.light);
    rect(ctx, 26, 19, 1, 16, p.shadow);
    rect(ctx, 37, 19, 1, 16, p.shadow);
    // Hips
    rect(ctx, 26, 35, 12, 3, p.shadow);
    // Long legs
    rect(ctx, 26, 38, 5, 20, p.light);
    rect(ctx, 26, 38, 1, 20, p.shadow);
    rect(ctx, 33, 38, 5, 20, p.light);
    rect(ctx, 37, 38, 1, 20, p.shadow);
  },
  mounts: {
    [SLOT.HEAD]:   { anchor: { x: 32, y: 2 } },
    [SLOT.FACE]:   { anchor: { x: 32, y: 7 } },
    [SLOT.HAT]:    { anchor: { x: 32, y: 2 } },
    [SLOT.TORSO]:  { anchor: { x: 32, y: 17 } },
    [SLOT.WAIST]:  { anchor: { x: 32, y: 35 } },
    [SLOT.FOOT_L]: { anchor: { x: 28, y: 57 } },
    [SLOT.FOOT_R]: { anchor: { x: 36, y: 57 } },
  },
};
